<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3 py-3">
          <CommonFieldString
              v-model="currentItem.part_number"
              :label="$t('part_number')"
              class="mt-3"
          ></CommonFieldString>
          <CommonPartialSelectFromTable
              v-model="currentItem.provider_uid"
              :label="$t('provider')"
              dto-list-query="ProviderListQueryDTO"
              store-name="SelectProvider"
              :sort-by="['name']"
              class="mt-3"
          >
          </CommonPartialSelectFromTable>
          <CommonPartialSelectFromTable
              v-if="!embedded"
              v-model="currentItem.component_uid"
              :label="$t('article')"
              dto-list-query="ComponentShortListQueryDTO"
              :sort-by="['article_display', 'alias']"
              item-text="alias_article"
              class="mt-3"
          >
          </CommonPartialSelectFromTable>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonFieldString from "@/components/Common/CommonFieldString";

export default {
  name: "PartNumberDetail",

  props: {
    uidItem: {default: null},
    embedded: {default: false},
    storeName: {type: [String], default: 'PartNumberDetail'},
    dtoDetailQuery: {default: 'PartNumberDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PartNumberActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'PartNumberSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'PartNumberValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'PartNumberBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'PartNumberTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>